export default from './InputWithSlider';



// WEBPACK FOOTER //
// ./src/sharedComponents/InputWithSlider/index.js